import React, { useState, useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import numeral from 'numeral'

const CurrencyInput = ({
  value = 0,
  onChange,
  currency = 'EUR',
  placeholder = '0,00',
  className = 'user-input form__input',
  name,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)

  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
  }

  // Sincronizar el valor inicial y cambios externos
  useEffect(() => {
    if (!isFocused) {
      if (value || value === 0) {
        const formatted = value ? numeral(value).format('0,0.00') : ''
        setDisplayValue(formatted)
      } else {
        setDisplayValue('')
      }
    }
  }, [value, isFocused])

  const handleChange = (e) => {
    const inputValue = e.target.value

    // Permitir escribir libremente mientras se está editando
    setDisplayValue(inputValue)

    // Remover todo excepto números, puntos y comas
    const cleanValue = inputValue.replace(/[^0-9.,]/g, '')

    // Reemplazar coma por punto para el cálculo
    const normalizedValue = cleanValue.replace(/,/g, '.')

    // Convertir a número
    const numericValue = parseFloat(normalizedValue) || 0

    // Llamar onChange con el valor numérico
    if (onChange) {
      onChange({
        target: {
          name: name,
          value: numericValue,
        },
      })
    }
  }

  const handleFocus = () => {
    setIsFocused(true)
    // Mostrar el valor sin formato para facilitar la edición
    const rawValue = value ? value.toString().replace('.', ',') : ''
    setDisplayValue(rawValue)
  }

  const handleBlur = () => {
    setIsFocused(false)
    // Formatear cuando pierda el foco
    if (value || value === 0) {
      const formatted = value ? numeral(value).format('0,0.00') : ''
      setDisplayValue(formatted)
    }
  }

  return (
    <InputGroup>
      <InputGroup.Prepend>
        <InputGroup.Text
          style={{
            backgroundColor: '#d9d9d91a',
            border: '1px solid #00a499',
            color: '#00a499',
            fontWeight: '500',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          }}
        >
          {currencySymbols[currency]}
        </InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type='text'
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={className}
        {...props}
      />
    </InputGroup>
  )
}

export default CurrencyInput
